import api from './api/axiosConfig';

const clubService = {
  // Get all clubs with optional filters
  getClubs: async (params = {}) => {
    try {
      const response = await api.get('/clubs/api/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching clubs:', error);
      throw error;
    }
  },

  // Get a single club by ID
  getClub: async (id) => {
    try {
      const response = await api.get(`/clubs/api/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching club:', error);
      throw error;
    }
  },

  // Create a new club
  createClub: async (clubData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(clubData).forEach((key) => {
        if (key === 'images' && Array.isArray(clubData[key])) {
          clubData[key].forEach((image) => {
            formData.append('images', image);
          });
          return;
        }
        if (key === 'images') return;
        if (key === 'display_image_index' && clubData[key] !== undefined && clubData[key] !== null) {
          formData.append(key, String(clubData[key]));
          return;
        }
        const val = clubData[key];
        if (val !== undefined && val !== null && val !== '') {
          formData.append(key, val);
        }
      });

      const response = await api.post('/clubs/api/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating club:', error);
      throw error;
    }
  },

  // Update a club
  updateClub: async (id, clubData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(clubData).forEach((key) => {
        if (key === 'images' && Array.isArray(clubData[key])) {
          clubData[key].forEach((image) => {
            formData.append('images', image);
          });
          return;
        }
        if (key === 'images') return;
        if (key === 'display_image_index' && clubData[key] !== undefined && clubData[key] !== null) {
          formData.append(key, String(clubData[key]));
          return;
        }
        const val = clubData[key];
        if (val !== undefined && val !== null && val !== '') {
          formData.append(key, val);
        }
      });

      const response = await api.put(`/clubs/api/${id}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating club:', error);
      throw error;
    }
  },

  // Delete a club
  deleteClub: async (id) => {
    try {
      const response = await api.delete(`/clubs/api/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting club:', error);
      throw error;
    }
  },

  // Get related clubs
  getRelatedClubs: async (clubId, params = {}) => {
    try {
      const response = await api.get('/clubs/api/', { 
        params: {
          ...params,
          exclude: clubId,
          limit: 4
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching related clubs:', error);
      throw error;
    }
  },
};

export default clubService;
